{
  "page": {
    "title": "Reglas y cartas",
    "tagline": "Todo lo necesario para levantar tu ciudad: cómo se juega, qué significa cada icono y el catálogo completo de cartas y maravillas.",
    "edition": "Basado en la 2ª edición (2020)",
    "home": "Inicio",
    "homeAria": "Volver al inicio",
    "navLabel": "Secciones de la guía",
    "toTop": "Volver arriba"
  },
  "nav": {
    "summary": "Resumen de reglas",
    "icons": "Iconos",
    "cards": "Cartas",
    "wonders": "Maravillas"
  },
  "summary": {
    "tocLabel": "Índice del resumen",
    "goal": {
      "title": "Objetivo",
      "lead": "Gobiernas una de las grandes ciudades de la Antigüedad durante tres eras. Cuando termina la tercera, gana quien haya reunido más <vp/> puntos de victoria.",
      "body": "No hay un único camino al triunfo: los puntos salen del ejército, del tesoro, de la maravilla y de los edificios que construyas. Vigila a tus dos vecinos, porque son a la vez tus socios comerciales y tus rivales en el campo de batalla.",
      "ways": "Siete formas de sumar puntos"
    },
    "setup": {
      "title": "Preparación",
      "tiles": [
        { "label": "3 a 7 jugadores", "text": "Cada ciudad se sienta entre dos vecinos, uno a su izquierda y otro a su derecha. Solo interactúas con ellos." },
        { "label": "Una maravilla", "text": "Cada jugador recibe un tablero (al azar o elegido, según la sala). Su recurso inicial produce desde el primer turno." },
        { "label": "Lado Día o Noche", "text": "Cada uno elige en secreto el lado de su tablero y se revelan todos juntos. La sala también puede fijar Día, Noche o azar." },
        { "label": "3 monedas", "text": "Todos empiezan la partida con 3 <coin/> en el tesoro." }
      ],
      "decks": "El juego prepara los mazos por ti: en cada era entran las cartas cuyo marcador de jugadores es igual o menor que el número de la mesa, siete por jugador. En la Era III se añaden además, al azar, tantos gremios como jugadores más dos."
    },
    "age": {
      "title": "Una era, paso a paso",
      "lead": "La partida dura tres eras. Al empezar cada una recibes una mano de 7 cartas y se juegan 6 turnos.",
      "stepsTitle": "Cada turno",
      "steps": [
        { "label": "Elige", "text": "Escoge en secreto una carta de tu mano. Todos eligen a la vez: nadie espera su turno." },
        { "label": "Resuelve", "text": "Cuando todos han elegido, las jugadas se revelan y se aplican al mismo tiempo." },
        { "label": "Pasa", "text": "Entregas el resto de tu mano a un vecino y recibes la del otro." }
      ],
      "actionsTitle": "Con la carta elegida haces una de estas tres cosas",
      "actions": {
        "build": { "title": "Construir el edificio", "text": "Pagas su coste y la colocas en tu ciudad; su efecto se activa desde ese momento. Nunca puedes tener dos edificios con el mismo nombre." },
        "stage": { "title": "Erigir una etapa", "text": "Pagas el coste de la siguiente etapa de tu maravilla y metes la carta boca abajo bajo el tablero. Las etapas van en orden." },
        "sell": { "title": "Vender la carta", "text": "La descartas boca abajo y cobras 3 <coin/> del banco. Siempre puedes hacerlo, aunque no tengas con qué pagar." }
      },
      "passTitle": "Hacia dónde pasan las manos",
      "passLeft": "a la izquierda",
      "passRight": "a la derecha",
      "eraLabel": "Era {{age}}",
      "turnsTitle": "Los seis turnos",
      "turnLabel": "Turno {{n}}",
      "turn6": "Te quedan dos cartas: juegas una y la otra va al descarte sin darte monedas.",
      "endOfAge": "Tras el sexto turno se resuelven los conflictos militares y empieza la era siguiente."
    },
    "trade": {
      "title": "Costes y comercio",
      "lead": "El coste aparece en la esquina superior izquierda de cada carta. Puede no haber coste, pedir monedas (que van al banco) o pedir recursos.",
      "own": [
        "<b>Tu producción</b> sale de tu propia ciudad: el recurso inicial de la maravilla, las cartas marrones y grises, y algunas amarillas y etapas. Producir no consume nada: cada turno vuelves a disponer de todo.",
        "Cada carta de producción entrega lo que muestra una vez por turno. Si sus recursos están separados por «/», ese turno eliges solo uno de ellos."
      ],
      "buyTitle": "Comprar a los vecinos",
      "buy": [
        "Lo que te falte puedes comprárselo a tus vecinos directos: pagas <b>2 <coin/></b> por cada unidad al dueño del recurso.",
        "El vecino no puede negarse y no pierde nada: su recurso le sigue sirviendo a él ese mismo turno. Los dos vecinos pueden comprar lo mismo.",
        "Cada unidad concreta de un vecino solo se te vende una vez por turno. Si su carta ofrece «uno a elegir», eliges tú cuál compras."
      ],
      "canTitle": "Se puede comprar",
      "can": ["El recurso inicial de su maravilla", "Lo que producen sus cartas marrones", "Lo que producen sus cartas grises"],
      "cannotTitle": "No se puede comprar",
      "cannot": ["Lo que producen sus cartas amarillas", "Lo que producen sus etapas de maravilla", "Lo que construye en ese mismo turno"],
      "priceNormal": "Precio normal",
      "priceDiscount": "Con descuento",
      "discounts": "Los <b>Puestos comerciales</b> rebajan a 1 <coin/> las materias primas del vecino hacia el que apunta su flecha; el <b>Mercado</b> rebaja a 1 <coin/> las manufacturas de ambos vecinos.",
      "timingTitle": "Dos detalles importantes",
      "timing": [
        "Solo puedes gastar las monedas que tenías al empezar el turno. Lo que cobres durante el turno (al vender o al comerciar) llega después.",
        "Los recursos, propios o comprados, no se guardan: sirven para la jugada de ese turno y al siguiente vuelves a empezar."
      ],
      "helper": "Al elegir una carta, el juego calcula las mejores formas de pagarla (más barata a un vecino, al otro o repartida) y solo tienes que escoger una."
    },
    "chains": {
      "title": "Encadenamientos",
      "lead": "Muchas cartas de las Eras II y III muestran junto al coste el nombre de un edificio anterior. Si ya lo tienes en tu ciudad, construyes la nueva carta <b>gratis</b>, sin recursos ni monedas.",
      "example": "Ejemplo: con la Botica de la Era I tienes gratis el Dispensario en la Era II, y este a su vez te regala la Logia en la Era III.",
      "note": "El encadenamiento solo sirve para construir el edificio, nunca para una etapa de maravilla. En el catálogo de cartas verás las cadenas de cada carta en los dos sentidos."
    },
    "military": {
      "title": "Conflictos militares",
      "lead": "Al final de cada era, cada ciudad compara sus <shield/> escudos (cartas rojas y algunas etapas) con los de cada uno de sus dos vecinos: dos batallas por era.",
      "win": "Victoria",
      "loss": "Derrota",
      "tie": "Empate",
      "tieText": "Nadie recibe ficha",
      "lossText": "En cualquier era",
      "note": "Las fichas se acumulan y al final de la partida se suman en la categoría militar."
    },
    "scoring": {
      "title": "Puntuación final",
      "lead": "Al terminar la Era III se suman siete categorías, en este orden en la hoja de puntuación:",
      "categories": {
        "military": "La suma de tus fichas de victoria y de derrota.",
        "treasury": "1 PV por cada 3 monedas que tengas. Las sobrantes no puntúan.",
        "wonder": "Los PV de las etapas que hayas erigido.",
        "civil": "Los PV impresos en tus cartas azules.",
        "science": "Según tus símbolos científicos (ver abajo).",
        "commercial": "Los PV de tus cartas amarillas de la Era III.",
        "guilds": "Lo que indique cada una de tus cartas moradas."
      },
      "scienceTitle": "Cómo puntúa la ciencia",
      "science": [
        "Cuenta cuántas veces tienes cada símbolo y eleva ese número al cuadrado: 1 da 1 PV, 2 dan 4, 3 dan 9, 4 dan 16…",
        "Además, cada trío de símbolos distintos (<compass/> <gear/> <tablet/>) vale <b>7 PV</b> extra.",
        "Los comodines <wild/> (Babilonia y el Gremio de científicos) se convierten al final en el símbolo que más puntos te dé. El juego lo calcula por ti."
      ],
      "exampleLabel": "Ejemplo",
      "exampleSet": "un trío",
      "tieTitle": "Desempate",
      "tie": "Si hay empate a puntos, gana quien tenga más monedas. Si también empatan en monedas, comparten la victoria."
    },
    "specials": {
      "title": "Maravillas con efectos especiales",
      "lead": "Algunas etapas no dan puntos ni recursos, sino una habilidad. Así funcionan:",
      "halikarnassos": {
        "title": "Halicarnaso",
        "side": "Día y Noche",
        "text": "Al final del turno en que erigiste la etapa, revisas todo el descarte (incluidas las cartas descartadas en ese mismo turno), eliges una y la construyes gratis. No puede ser un edificio que ya tengas; si no hay ninguno válido, el efecto se pierde."
      },
      "babylon": {
        "title": "Babilonia",
        "side": "Noche",
        "text": "Su primera etapa te deja aprovechar la 7ª carta de cada era: cuando todos terminan el turno 6, la juegas en un turno extra (construir, etapa o vender). Ese turno tu producción se renueva, compras a los vecinos según su estado actual y ya puedes gastar lo ganado en el turno 6. Vale aunque erijas la etapa en el propio turno 6. Si Halicarnaso actúa ese turno, se resuelve antes."
      },
      "olympiaDay": {
        "title": "Olimpia",
        "side": "Día",
        "text": "Con la segunda etapa, cualquier carta de un color que todavía no tengas en tu ciudad se construye gratis (incluida la moneda de las marrones)."
      },
      "olympiaNight": {
        "title": "Olimpia",
        "side": "Noche",
        "text": "La primera etapa hace gratis la carta que construyas en el primer turno de cada era; la segunda, la del sexto turno."
      },
      "note": "Ninguno de estos efectos permite erigir gratis una etapa de maravilla: solo se aplican a edificios."
    },
    "digital": {
      "title": "Reglas de la versión digital",
      "lead": "Algunas situaciones solo existen jugando en línea. Así las resolvemos:",
      "session": {
        "title": "Tu sesión",
        "text": "Sin cuentas ni contraseñas: entras con un nombre y la sesión queda guardada en este navegador. Si abres el juego en otra pestaña o dispositivo, puedes tomar el control desde allí."
      },
      "disconnect": {
        "title": "Desconexiones",
        "text": "Si alguien pierde la conexión, la mesa lo espera: el turno no avanza sin su elección y, al volver, retoma su ciudad tal como la dejó. Solo si nadie de la mesa sigue conectado durante mucho tiempo (dos días por defecto) la partida se cancela."
      },
      "host": {
        "title": "Si se va el anfitrión",
        "text": "Cuando el anfitrión lleva un rato desconectado (un minuto por defecto), su papel pasa automáticamente a otro jugador que siga conectado."
      },
      "retire": {
        "title": "Retirar a un ausente",
        "text": "Si un jugador lleva desconectado más de unos minutos (3 con la configuración por defecto), el anfitrión puede retirarlo. Su ciudad queda congelada, igual que si hubiera abandonado."
      },
      "frozen": {
        "title": "Abandono: la ciudad congelada",
        "text": "Quien abandona la partida no desaparece de la mesa; su ciudad se queda quieta:",
        "items": [
          "Conserva su asiento, así que nadie cambia de vecinos.",
          "Sigue vendiendo recursos, y sus escudos y cartas cuentan para los conflictos y los gremios de sus vecinos.",
          "Ya no construye: cada turno descarta una carta al azar de su mano, sin cobrar monedas, y la mano sigue rotando. Esas cartas van al descarte, así que Halicarnaso puede recuperarlas.",
          "Pierde sus efectos especiales: si le tocaba jugar la 7ª carta de Babilonia, esa carta se descarta.",
          "No entra en la clasificación final: aparece como «abandonó»."
        ],
        "end": "Si quedan menos de dos jugadores activos, la partida termina y el último que sigue en juego gana por abandono."
      }
    }
  },
  "icons": {
    "lead": "Los símbolos que verás en las cartas, en los tableros de maravilla y en la mesa de juego. En el catálogo de cartas, pulsa cualquiera para leer su descripción completa.",
    "groups": {
      "raw": "Materias primas",
      "manufactured": "Manufacturas",
      "economy": "Monedas y puntos",
      "military": "Militar",
      "science": "Ciencia",
      "wonder": "Maravilla",
      "trade": "Vecinos y comercio",
      "colors": "Colores de carta"
    },
    "rawText": "Recurso básico. Lo producen las cartas marrones y algunas maravillas.",
    "manufacturedText": "Recurso elaborado. Lo producen las cartas grises y algunas maravillas.",
    "items": {
      "coin": { "name": "Moneda", "text": "En un coste, monedas que pagas al banco. Como efecto, monedas que cobras al instante." },
      "vp": { "name": "Puntos de victoria (PV)", "text": "Puntos que sumas al final de la partida. El número indica cuántos." },
      "choice": { "name": "Uno a elegir", "text": "Recursos separados por «/»: cada turno produces solo uno de ellos, el que necesites." },
      "shield": { "name": "Escudo", "text": "Fuerza militar. Cada escudo cuenta en los conflictos de final de era." },
      "win": { "name": "Ficha de victoria", "text": "Se gana al superar en escudos a un vecino: vale 1, 3 o 5 PV según la era." },
      "loss": { "name": "Ficha de derrota", "text": "Se recibe al tener menos escudos que un vecino: resta 1 PV." },
      "compass": { "name": "Compás", "text": "Símbolo científico." },
      "gear": { "name": "Engranaje", "text": "Símbolo científico." },
      "tablet": { "name": "Tablilla", "text": "Símbolo científico." },
      "wild": { "name": "Comodín científico", "text": "Al final cuenta como el símbolo que más puntos te dé." },
      "stageBuilt": { "name": "Etapa erigida", "text": "Etapa de maravilla ya construida. También se cuenta en algunas cartas amarillas y gremios." },
      "stagePending": { "name": "Etapa pendiente", "text": "Etapa que aún puedes construir con una carta de tu mano." },
      "left": { "name": "Vecino izquierdo", "text": "El efecto se aplica a la ciudad de tu izquierda." },
      "right": { "name": "Vecino derecho", "text": "El efecto se aplica a la ciudad de tu derecha." },
      "both": { "name": "Ambos vecinos", "text": "El efecto se aplica a las dos ciudades vecinas." },
      "discount": { "name": "Descuento comercial", "text": "Compras esos recursos al vecino indicado por 1 moneda en lugar de 2." },
      "per": { "name": "Por cada…", "text": "El valor se multiplica por cada carta del color indicado (o etapa) en las ciudades que señalan las flechas." },
      "chain": { "name": "Encadenamiento", "text": "Construyes la carta gratis si ya tienes el edificio indicado." }
    },
    "colors": {
      "brown": { "name": "Materias primas", "text": "Producen madera, piedra, arcilla o mineral. Tus vecinos pueden comprártelas." },
      "grey": { "name": "Manufacturas", "text": "Producen vidrio, papiro o tela. Tus vecinos pueden comprártelas." },
      "blue": { "name": "Edificios civiles", "text": "Dan puntos de victoria directos." },
      "yellow": { "name": "Edificios comerciales", "text": "Monedas, descuentos en el comercio, recursos para ti solo y, en la Era III, PV." },
      "red": { "name": "Edificios militares", "text": "Dan escudos para los conflictos." },
      "green": { "name": "Edificios científicos", "text": "Dan símbolos de ciencia." },
      "purple": { "name": "Gremios", "text": "Solo en la Era III. Puntúan según lo que tú o tus vecinos hayáis construido." }
    }
  },
  "cards": {
    "search": "Buscar por nombre…",
    "searchAria": "Buscar carta por nombre",
    "clearSearch": "Borrar búsqueda",
    "era": "Era",
    "players": "Jugadores",
    "color": "Color",
    "all": "Todas",
    "allPlayers": "Todos",
    "guilds": "Gremios",
    "count_one": "{{count}} carta",
    "count_other": "{{count}} cartas",
    "reset": "Quitar filtros",
    "empty": "Ninguna carta coincide con estos filtros.",
    "eraTitle": "Era {{age}}",
    "guildTitle": "Gremios",
    "passLeft": "Las manos pasan a la izquierda",
    "passRight": "Las manos pasan a la derecha",
    "guildPool": "En cada partida se usan al azar tantos gremios como jugadores más dos.",
    "guildPoolN": "Con {{players}} jugadores se reparten {{count}} de los 10 al azar.",
    "deckSize": "Mazo de {{count}} cartas con {{players}} jugadores",
    "copies_one": "×{{count}}",
    "copies_other": "×{{count}}",
    "copiesTitle_one": "{{count}} copia con {{players}} jugadores",
    "copiesTitle_other": "{{count}} copias con {{players}} jugadores",
    "hint": "Pulsa una carta para ver su descripción, sus copias y sus encadenamientos."
  },
  "detail": {
    "cost": "Coste",
    "effect": "Efecto",
    "free": "Sin coste",
    "copies": "Copias según el número de jugadores",
    "playersShort": "{{n}} jug.",
    "ageRow": "Era {{age}}",
    "markers": "Marcadores impresos: {{list}}",
    "guildCopies": "Hay una sola copia. En cada partida se reparten al azar tantos gremios como jugadores más dos.",
    "chains": "Encadenamientos",
    "chainFrom": "Gratis si ya tienes",
    "chainTo": "Te da gratis",
    "noChains": "Esta carta no forma parte de ninguna cadena.",
    "tradeable": "Tus vecinos pueden comprarte lo que produce.",
    "notTradeable": "Lo que produce es solo para ti: los vecinos no pueden comprarlo.",
    "category": "Carta {{color}} · {{category}}",
    "sameName": "Existe en más de una era con el mismo nombre; no puedes construir dos iguales."
  },
  "wonders": {
    "lead": "Cada maravilla tiene dos lados. El lado Día es más directo; el lado Noche cambia el número de etapas y sus efectos. El recurso inicial es el mismo en los dos lados y tus vecinos pueden comprártelo.",
    "jump": "Ir a una maravilla",
    "startResource": "Recurso inicial",
    "day": "Lado Día",
    "night": "Lado Noche",
    "stage": "Etapa {{n}}",
    "stages_one": "{{count}} etapa",
    "stages_other": "{{count}} etapas",
    "vpTotal": "{{count}} PV directos"
  }
}
